import { render, staticRenderFns } from "./BSclass.vue?vue&type=template&id=0848ba14&scoped=true&"
import script from "./BSclass.vue?vue&type=script&lang=js&"
export * from "./BSclass.vue?vue&type=script&lang=js&"
import style0 from "./BSclass.vue?vue&type=style&index=0&id=0848ba14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848ba14",
  null
  
)

export default component.exports